import _ from 'lodash';

export default function getDistinctProductIds(fulfillmentOrderItems) {
	const productIds = [];
	_.forEach(fulfillmentOrderItems, item => {
		if (productIds.indexOf(item.productId) === -1) {
			productIds.push(item.productId);
		}
	});
	return productIds;
}



// WEBPACK FOOTER //
// ./src/core/utils/getDistinctProductIds.js